import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '../../core/models';
import { AppTheme, AuthService, SessionService, ThemeService } from '../../core/services';

import { initials } from '../../core/utils/initials';

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar {
  readonly user$: Observable<User | null>;
  readonly initials = initials;

  /** Collapsed by default this is a rarely-used, high-stakes section, not
   *  somewhere to land on every page load for a superadmin who's mostly
   *  using the app as a regular user the rest of the time. */
  platformNavExpanded = false;

  readonly userMenuOpen = signal(false);

  readonly themeOptions: { value: AppTheme; label: string }[] = [
    { value: 'light', label: 'Light' },
    { value: 'dark', label: 'Dark' },
    { value: 'system', label: 'System' },
  ];

  constructor(
    private sessionService: SessionService,
    private authService: AuthService,
    private router: Router,
    readonly theme: ThemeService,
  ) {
    this.user$ = this.sessionService.user$;
  }

  togglePlatformNav(): void {
    this.platformNavExpanded = !this.platformNavExpanded;
  }

  /** Escape closes the menu and hands focus back to the row that opened it. */
  closeUserMenu(trigger: HTMLElement): void {
    if (!this.userMenuOpen()) return;
    this.userMenuOpen.set(false);
    trigger.focus();
  }

  logout(): void {
    this.userMenuOpen.set(false);
    // Always completes (the API returns 204 unconditionally) fire-and-forget, then redirect.
    this.authService.logout().subscribe(() => this.router.navigate(['/login']));
  }
}
